import request from '@/utils/request'
const BASE_URL = '/Visitor'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  vList(data) {
    return request({
      url: BASE_URL + '/VVList',
      method: 'post',
      data
    })
  },
}